import { render, staticRenderFns } from "./PeriodButtons.vue?vue&type=template&id=38960570&scoped=true"
import script from "./PeriodButtons.vue?vue&type=script&lang=js"
export * from "./PeriodButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38960570",
  null
  
)

export default component.exports